import { PREVIEW_IFRAME_READY, CLEAR_IFRAME_TIMEOUT_ERROR, CLEAR_UPDATED_THEME_SETTINGS, RELOAD_IFRAME_PREVIEW, IFRAME_PREVIEW_LOADED, IFRAME_PREVIEW_LOAD_FAILED, SET_IFRAME_TIMEOUT_ERROR, SET_IFRAME_PREVIEW_LOADING, FETCH_PREVIEW_DOMAIN, SET_PORTALS_HMR, PORTALS_THEME_UPDATE_RECEIVED } from './ActionTypes';
import * as previewDomainClient from 'ContentUtils/api/previewDomainClient';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
export const clearUpdatedThemeSettings = () => {
  return {
    type: CLEAR_UPDATED_THEME_SETTINGS
  };
};
export const previewIframeReady = () => {
  return {
    type: PREVIEW_IFRAME_READY
  };
};
export const reloadIframePreview = () => {
  return {
    type: RELOAD_IFRAME_PREVIEW
  };
};
export const iframePreviewLoaded = () => {
  return {
    type: IFRAME_PREVIEW_LOADED
  };
};
export const iframePreviewLoadFailed = () => {
  return {
    type: IFRAME_PREVIEW_LOAD_FAILED
  };
};
export const setIframePreviewLoading = () => {
  return {
    type: SET_IFRAME_PREVIEW_LOADING
  };
};
export const setIframeTimeoutError = () => {
  return {
    type: SET_IFRAME_TIMEOUT_ERROR
  };
};
export const clearIframeTimeoutError = () => {
  return {
    type: CLEAR_IFRAME_TIMEOUT_ERROR
  };
};
export const setPortalsHMR = payload => {
  return {
    type: SET_PORTALS_HMR,
    payload
  };
};
export const portalsThemeUpdateReceived = () => {
  return {
    type: PORTALS_THEME_UPDATE_RECEIVED
  };
};
const previewDomainRequeseted = () => ({
  type: FETCH_PREVIEW_DOMAIN,
  requestStatus: RequestStatusTypes.PENDING
});
const previewDomainReceived = result => ({
  type: FETCH_PREVIEW_DOMAIN,
  payload: result,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const previewDomainFetchFailed = error => ({
  type: FETCH_PREVIEW_DOMAIN,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchPreviewDomain = () => dispatch => {
  dispatch(previewDomainRequeseted());
  previewDomainClient.fetchPreviewDomain().then(result => {
    dispatch(previewDomainReceived(result));
  }, error => {
    dispatch(previewDomainFetchFailed(error));
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};